<script setup lang="ts">
withDefaults(
  defineProps<{
    error?: boolean;
    warning?: boolean;
  }>(),
  { error: false, warning: false }
);
</script>

<template>
  <Icon
    :name="
      warning
        ? 'carbon:warning'
        : error
        ? 'carbon:close-outline'
        : 'carbon:checkmark-outline'
    "
    :class="[
      'text-xl',
      warning ? 'text-orange-600' : error ? 'text-red-500' : 'text-green-500',
    ]"
  />
</template>
